import { alpha } from "@mui/material";
import { grey, blue, red } from "@mui/material/colors";

const styles = {
  skeletonMainContainer: {
    display: "flex",
    padding: "0px !important",
  },
  skeletonSecondaryContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    marginBottom: "12px",
    gap: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  badge: {
    backgroundColor: blue[50],
    minWidth: "24px",
    height: "24px",
    color: blue[700],
    fontWeight: "bold",
    borderRadius: "12px",
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: grey[900],
  },
  chipsContainer: {
    display: 'flex',
    gap: 1,
  },
  creditsChip: {
    fontSize: "1rem",
    color: '#53CA98',
    borderRadius: 40,
    backgroundColor: alpha('#53CA98', 0.1),
  },
  balanceChip: {
    fontSize: "1rem",
    color: blue[500],
    borderRadius: 40,
    backgroundColor: alpha(blue[500], 0.1),
  },
  circleAvatar: {
    width: "60px",
    minWidth: "60px",
    height: "60px",
    marginRight: "16px",
    backgroundColor: grey[300],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 3,
  },
  iconCircleAvatar: {
    width: "46px",
    height: "60px",
    color: grey[800],
  },
  delivererDetailsContainer: {
    display: "flex",
    justifyContent: "spaceBetwen",
    padding: "0 !important",
  },
  delivererDetailsInfoContainer: {
    display: "flex",
    justifyContent: "spaceBetwen",
    padding: "0 !important",
  },
  tabContainer: {
    marginTop: "24px",
  },
  activeButton: {
    minWidth: "140px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    minWidth: "140px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
};

export default styles;
